import React from 'react';

import PhotoIcon from './icons/photo';
import PlayIcon from './icons/play';

import { MediaType } from '../../types';

export interface MediaIndicatorProps {
  className?: string;
  height?: number;
  type: MediaType;
}

export const icons = {
  snapshot: <PhotoIcon />,
  video: <PlayIcon />,
};

export default class MediaIndicatorIcon extends React.Component<
  MediaIndicatorProps,
  any
> {
  static defaultProps = {
    height: 46,
    type: 'snapshot',
  };

  public render() {
    const [baseWidth, baseHeight] = [46, 44];
    const { className, height, type } = this.props;
    const width = baseWidth * height / baseHeight;

    return (
      <svg
        opacity={0.9}
        height={height}
        width={width}
        className={className}
        viewBox={`0 0 ${baseWidth} ${baseHeight}`}
      >
        {icons[type]}
      </svg>
    );
  }
}
